import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-conversation-modal',
  templateUrl: './add-conversation-modal.component.html',
  styleUrls: ['./add-conversation-modal.component.scss']
})
export class AddConversationModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
